const SYNC_REQUEST_APPROVED_STATUS = 'APPROVED';
const SYNC_REQUEST_IN_PROGRESS_STATUS = 'IN PROGRESS';
const SYNC_REQUEST_INACTIVE_STATUS = 'INACTIVE';

module.exports = {
  SYNC_REQUEST_APPROVED_STATUS,
  SYNC_REQUEST_IN_PROGRESS_STATUS,
  SYNC_REQUEST_INACTIVE_STATUS,
};
